/* eslint-disable prettier/prettier */
/* eslint-disable import/named */

import "../../styles/Sidebar.scss";
import "../../styles/SidebarV2.scss";
import { Button } from "reactstrap";
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  WithFirebaseProps,
  firestoreConnect,
  isLoaded
} from "react-redux-firebase";
import { IProfile } from "../claims/new/typings";
import { RouteComponentProps, withRouter } from "react-router-dom";
import {
  arrowDownLeft,
  arrowUpRight,
  checkSquare,
  home,
  inbox,
  info,
  menu,
  plus,
  power,
  user,
  users
} from "react-icons-kit/feather";
import { compose } from "redux";
import { connect } from "react-redux";
import AsyncCSV from "./AsyncCSV";
import Icon, { IconProp } from "react-icons-kit";
import InfoPanel from "../modals/infopanel/InfoPanel";
import NewsIcon from "../../images/newspaper.svg";
import React, { Component, ReactElement } from "react";
import _ from "lodash";
import ageLogo from "../../images/new-images/AGE GLASS claims-09-03.svg";
import claimsCompletedIcon from "../../images/svg-files/completed-green.svg";
import claimsCompletedIconWhite from "../../images/svg-files/completed-white.svg";
import claimsReceivedIcon from "../../images/svg-files/incoming-green.svg";
import claimsReceivedIconWhite from "../../images/svg-files/incoming-white.svg";
import claimsSentIcon from "../../images/svg-files/outgoing-green.svg";
import claimsSentIconWhite from "../../images/svg-files/outgoing-white.svg";
import complaintsIcon from "../../images/svg-files/complaint-green.svg";
import complaintsIconWhite from "../../images/new-images/complaints.svg";
import history from "../../helpers/history";
import membersIconPlatform from "../../images/svg-files/members.svg";
import menuToggleIcon from "../../images/new-images/icons_AGE platform-01.svg";
import moment from "moment";
import newClaimIcon from "../../images/new-images/icons_AGE platform-05.svg";
import newsIconPlatform from "../../images/svg-files/news.svg";
import newsIconPlatformWhite from "../../images/svg-files/news-white.svg";
const initialState: SideBarState = {
  isOpen: {
    infoPanel: false
  },
  claimDetails: []
};
class Sidebar extends Component<
  WithFirebaseProps<any> & RouteComponentProps & SidebarProps,
  SideBarState
> {
  private static USE_NEW_V2_LAYOUT = true;
  constructor(props: any) {
    super(props);
    this.logout = this.logout.bind(this);
    this.state = { ...initialState };
    this.navigateTo = this.navigateTo.bind(this);
    this.toggleInfoPanel = this.toggleInfoPanel.bind(this);
    this.renderMeta = this.renderMeta.bind(this);
  }

  navigateTo(route: string) {
    return () => {
      history.push(route);
    };
  }

  renderMeta(label: string) {
    const metaPages = ["incoming", "outgoing", "completed"];
    if (!_.includes(metaPages, label) || !this.props.ready) {
      return false;
    }
    const key = label as "incoming" | "outgoing" | "completed";
    const counts = this.props[key];
    return (
      <div className="sidebar-btn-meta">
        <div className="meta-text">{counts.count} Claims</div>
        <div className="meta-text">{counts.unclaimed} Unassigned</div>
      </div>
    );
  }

  renderButton(
    icon: IconProp,
    label: string,
    color: string,
    action: Function,
    routes?: string[]
  ): ReactElement {
    const {
      match: { path }
    } = this.props;
    const activeClass = routes && _.includes(routes, path) ? "active" : "";
    return (
      <Button
        className={`sidebar-button ${activeClass}`}
        onClick={() => action()}
      >
        <Icon icon={icon} size={24} className="sidebar-btn-icon" />
        <div className="sidebar-btn-main">
          <div className="sidebar-btn-text">{label}</div>
          {this.renderMeta(label.toLowerCase())}
        </div>
      </Button>
    );
  }

  toggleInfoPanel() {
    const { isOpen } = this.state;
    this.setState({ isOpen: { ...isOpen, infoPanel: !isOpen.infoPanel } });
  }

  logout() {
    this.props.firebase.logout();
  }

  private renderButtonV2(
    icon: IconProp | string,
    label: string,
    action: Function,
    routes?: string[],
    buttonClassName?: string,
    customSize?: { width: string; height: string },
    badge?: number,
    hoverIcon?: string
  ) {
    const {
      match: { path }
    } = this.props;
    const activeClass = routes && _.includes(routes, path) ? "active" : "";
    const isImageIcon = typeof icon === "string";
    const hoverClass = isImageIcon && hoverIcon ? "has-hover-icon" : "";
    const isCompactMode = this.props.isCompact;

    return (
      <button
        key={label}
        className={`sidebar-button-v2 ${
          buttonClassName || ""
        } ${hoverClass} ${activeClass} ${
          isCompactMode ? "sidebar-tooltip-target" : ""
        }`.trim()}
        data-tooltip={label}
        title={label}
        onClick={() => action()}
      >
        <div className="sidebar-icon-v2">
          {isImageIcon ? (
            <>
              <img
                src={icon as string}
                alt={label}
                className="icon-default"
                style={
                  customSize
                    ? { width: customSize.width, height: customSize.height }
                    : undefined
                }
              />
              {hoverIcon && (
                <img
                  src={hoverIcon}
                  alt={label}
                  className="icon-hover"
                  style={
                    customSize
                      ? { width: customSize.width, height: customSize.height }
                      : undefined
                  }
                />
              )}
            </>
          ) : (
            <Icon icon={icon} size={24} />
          )}
        </div>
        <div className="sidebar-text-v2">{label}</div>
        {badge != null && badge > 0 && (
          <span className="sidebar-badge-v2">{badge}</span>
        )}
      </button>
    );
  }

  private renderNewV2Layout() {
    const { isOpen } = this.state;

    if (!this.props.profile.partnerId) {
      return <></>;
    }

    const isAdmin = this.props.profile.partnerId === "Admin";
    const isCompact = this.props.isCompact;
    const isCompactMode = isCompact;
    const logoAction = isAdmin ? this.navigateTo("/admin-dashboard") : this.navigateTo("/");

    return (
      <div
        className={`app-sidebar-v2 ${isCompactMode ? "compact" : ""} ${
          isAdmin ? "admin-mode" : ""
        }`}
      >
        <button className={`logo-v2`} onClick={logoAction}>
          <img src={ageLogo} alt="AGE logo" />
        </button>

        <div className="sidebar-buttons-v2">
          <button
            className="menu-toggle-v2"
            onClick={this.props.onToggleSidebar}
            title={isCompactMode ? "Expand sidebar" : "Collapse sidebar"}
          >
            <img src={menuToggleIcon} alt="toggle sidebar" />
          </button>

          <InfoPanel isOpen={isOpen.infoPanel} toggle={this.toggleInfoPanel} />

          {isAdmin ? (
            <>
              {this.renderButtonV2(
                home,
                "Dashboard",
                this.navigateTo("/admin-dashboard"),
                ["/admin-dashboard"],
                "admin-nav-icon"
              )}
              {this.renderButtonV2(
                claimsReceivedIcon,
                "All claims ongoing",
                this.navigateTo("/all"),
                ["/all"],
                "sidebar-button-v2--user-image admin-nav-icon",
                undefined,
                undefined,
                claimsReceivedIconWhite
              )}
              {this.renderButtonV2(
                claimsCompletedIcon,
                "Completed Claims",
                this.navigateTo("/completed"),
                ["/completed"],
                "sidebar-button-v2--user-image admin-nav-icon",
                undefined,
                undefined,
                claimsCompletedIconWhite
              )}
              {this.renderButtonV2(
                newsIconPlatform,
                "News",
                this.navigateTo("/news-feed"),
                ["/news-feed"],
                "sidebar-button-v2--user-image admin-nav-icon",
                undefined,
                undefined,
                newsIconPlatformWhite
              )}
            </>
          ) : (
            <>
              {this.renderButtonV2(
                claimsReceivedIcon,
                "Claims Received",
                this.navigateTo("/incoming"),
                ["/incoming"],
                "sidebar-button-v2--user-image",
                undefined,
                this.props.incoming?.count,
                claimsReceivedIconWhite
              )}
              {this.renderButtonV2(
                claimsCompletedIcon,
                "Claims Completed",
                this.navigateTo("/completed"),
                ["/completed"],
                "sidebar-button-v2--user-image",
                undefined,
                undefined,
                claimsCompletedIconWhite
              )}
              {this.renderButtonV2(
                claimsSentIcon,
                "Claims Sent",
                this.navigateTo("/outgoing"),
                ["/outgoing"],
                "sidebar-button-v2--user-image",
                undefined,
                this.props.outgoing?.count,
                claimsSentIconWhite
              )}
              {this.renderButtonV2(
                complaintsIcon,
                "Complaints Management",
                this.navigateTo("/complaints"),
                ["/complaints", "/complaints/new"],
                "sidebar-button-v2--user-image complaints-icon compaints-icons",
                undefined,
                this.props.complaints?.attentionCount,
                complaintsIconWhite
              )}
            </>
          )}
        </div>

        <div className="sidebar-bottom-v2">
          {!isAdmin ? (
            <button
              className={`new-claim-btn-v2 ${
                isCompactMode ? "sidebar-tooltip-target" : ""
              }`}
              data-tooltip="New Claim"
              title="New Claim"
              onClick={this.navigateTo("/new-claim")}
            >
              <Icon icon={plus} size={24} />
              {!isCompactMode && <span>New Claim</span>}
            </button>
          ) : null}

          {isAdmin ? (
            <button
              className={`resources-btn-v2 ${
                isCompactMode ? "sidebar-tooltip-target" : ""
              }`}
              data-tooltip="Users"
              title="Users"
              onClick={this.navigateTo("/users")}
            >
              <Icon icon={user} size={30} />
              {!isCompactMode && <span>Users</span>}
            </button>
          ) : null}

          {isAdmin ? (
            <button
              className={`resources-btn-v2 ${
                isCompactMode ? "sidebar-tooltip-target" : ""
              }`}
              data-tooltip="Members"
              title="Members"
              onClick={this.navigateTo("/members")}
            >
              <div className="admin-bottom-image-icon">
                <img src={membersIconPlatform} alt="Members" />
              </div>
              {!isCompactMode && <span>Members</span>}
            </button>
          ) : null}

          {!isAdmin ? (
            <button
              className={`resources-btn-v2 ${
                isCompactMode ? "sidebar-tooltip-target" : ""
              }`}
              data-tooltip="Resources"
              title="Resources"
              onClick={this.toggleInfoPanel}
            >
              <Icon icon={info} size={32} />
              {!isCompactMode && <span>Resources</span>}
            </button>
          ) : (
            <button
              className={`resources-btn-v2 ${
                isCompactMode ? "sidebar-tooltip-target" : ""
              }`}
              data-tooltip="Info"
              title="Information"
              onClick={this.toggleInfoPanel}
            >
              <Icon icon={info} size={32} />
              {!isCompactMode && <span>Information</span>}
            </button>
          )}

          <button
            className={`logout-btn-v2 ${
              isCompactMode ? "sidebar-tooltip-target" : ""
            }`}
            data-tooltip="Logout"
            title="Logout"
            onClick={this.logout}
          >
            {isCompactMode && !isAdmin ? (
              <Icon icon={power} size={18} />
            ) : (
              <span>Logout</span>
            )}
          </button>
        </div>
      </div>
    );
  }

  private renderLegacyLayout() {
    const { isOpen } = this.state;

    if (!this.props.profile.partnerId) {
      return <></>;
    }

    return (
      <div>
        <button
          className="logo"
          onClick={
            this.props.profile.partnerId === "Admin"
              ? this.navigateTo("/all")
              : this.navigateTo("/")
          }
        >
          <img src={ageLogo} alt="AGE logo" />
          <h2>Dashboard</h2>
        </button>
        <div className="sidebar-buttons">
          <div className="spacer"></div>
          <InfoPanel isOpen={isOpen.infoPanel} toggle={this.toggleInfoPanel} />
          {this.props.profile.partnerId === "Admin" ? (
            <>
              {this.renderButton(
                inbox,
                "Global Lifetime Guarantee Code Verification",
                "default",
                this.navigateTo("/all"),
                ["/all"]
              )}
              {this.renderButton(
                users,
                "Users",
                "default",
                this.navigateTo("/users"),
                ["/users"]
              )}
              <AsyncCSV />
            </>
          ) : (
            <>
              {this.renderButton(
                arrowDownLeft,
                "Received",
                "default",
                this.navigateTo("/incoming"),
                ["/incoming"]
              )}
              {this.renderButton(
                arrowUpRight,
                "Sent",
                "default",
                this.navigateTo("/outgoing"),
                ["/outgoing"]
              )}
              {this.renderButton(
                checkSquare,
                "Completed",
                "default",
                this.navigateTo("/completed"),
                ["/completed"]
              )}
              {this.renderButton(
                inbox,
                "Global Lifetime Guarantee Code Verification",
                "default",
                this.navigateTo("/all"),
                ["/all"]
              )}
              <div className="spacer"></div>
              {this.renderButton(
                info,
                "Resources",
                "default",
                this.toggleInfoPanel
              )}
            </>
          )}
        </div>
        <div className="sidebar-bottom">
          {this.props.profile.partnerId === "Admin" ? (
            <Button
              className="new-claim-btn"
              color="new-claim"
              onClick={this.navigateTo("/news-feed")}
            >
              <div className="btn-icon">
                <img src={NewsIcon} alt="newsfeed icon" />
              </div>
              <div className="sidebar-btn-text">News Feed</div>
            </Button>
          ) : null}
          {this.props.profile.partnerId &&
          this.props.profile.partnerId !== "Admin" ? (
            <Button
              className="new-claim-btn"
              color="new-claim"
              onClick={this.navigateTo("/new-claim")}
            >
              <div className="btn-icon">
                <Icon icon={plus} size={24} />
              </div>
              <div className="sidebar-btn-text">New Claim</div>
            </Button>
          ) : null}
          <div className="version">
            <div>
              {" "}
              {!this.props.isCompact ? "AGE Dashboard v1.1.3" : "v1.1.3"}
            </div>
            {!this.props.isCompact ? (
              <Button className="btn btn-sm logout-btn" onClick={this.logout}>
                Logout
              </Button>
            ) : (
              <Button className="logout-button-sidebar" onClick={this.logout}>
                <Icon icon={power} />
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (Sidebar.USE_NEW_V2_LAYOUT) {
      return this.renderNewV2Layout();
    }
    return this.renderLegacyLayout();
  }
}

const preMapStateToProps = ({
  firebase: { profile }
}: {
  firebase: FirebaseReducer.Reducer;
}) => {
  return {
    profile: profile
  };
};

const mapQueryToProps = ({
  profile,
  firestore
}: {
  profile: IProfile;
  firestore: FirestoreReducer.Reducer;
}): ReduxFirestoreQueries => {
  if (!profile || !profile.isLoaded || profile.isEmpty) {
    return [];
  }
  let fromDate = moment("2000-01-01").toDate();
  let toDate = moment("2100-01-01").toDate();
  fromDate = new Date(fromDate);
  toDate = new Date(toDate);
  fromDate = firestore.Timestamp.fromDate(fromDate);
  toDate = firestore.Timestamp.fromDate(toDate);
  const isAdmin = profile.partnerId === "Admin";
  return [
    {
      collection: "partners",
      doc: isAdmin ? "AutoglassClinic" : profile.partnerId,
      storeAs: "partner"
    },
    {
      collection: "claims",
      where: [
        ["assign.partner", "==", profile.partnerId],
        [
          "status",
          "in",
          [
            "NEW",
            "CONTACTED",
            "BOOKED",
            "EXCESS_COLLECTED",
            "SERVICE DONE",
            "ACCEPTED",
            "INVOICED",
            "CANCELLED"
          ]
        ] //['active', '==', true],
      ],
      storeAs: "incomingClaims"
    },
    {
      collection: "claims",
      where: [
        ["assign.origin", "==", profile.partnerId],
        [
          "status",
          "in",
          [
            "NEW",
            "CONTACTED",
            "BOOKED",
            "EXCESS_COLLECTED",
            "SERVICE DONE",
            "ACCEPTED",
            "INVOICED",
            "CANCELLED"
          ]
        ] // ['active', '==', true],
      ],
      storeAs: "outgoingClaims"
    },
    isAdmin
      ? {
          collection: "claims",
          where: [["status", "==", "COMPLETED"]],
          storeAs: "completedClaims"
        }
      : {
          collection: "claims",
          where: [
            ["assign.partners", "array-contains", profile.partnerId],
            ["status", "==", "COMPLETED"]
          ],
          storeAs: "completedClaims"
        },
    isAdmin
      ? {
          collection: "complaints",
          storeAs: "complaints"
        }
      : {
          collection: "complaints",
          where: ["participantPartnerIds", "array-contains", profile.partnerId],
          storeAs: "complaints"
        },
    {
      collection: "partners",
      doc: isAdmin ? "AutoglassClinic" : profile.partnerId,
      storeAs: "partner"
    },
    {
      collection: "partners",
      storeAs: "partners"
    }
  ];
};

const mapStateToProps = ({ firestore }: any) => {
  const incomingClaims = _.pickBy(
    firestore.data.incomingClaims,
    (c) => !_.isNull(c)
  );
  const outgoingClaims = _.pickBy(
    firestore.data.outgoingClaims,
    (c) => !_.isNull(c)
  );
  const completedClaims = _.pickBy(
    firestore.data.completedClaims,
    (c) => !_.isNull(c)
  );
  const complaints = _.pickBy(
    firestore.data.complaints || {},
    (c) => !_.isNull(c)
  );
  const ready = isLoaded(incomingClaims) && isLoaded(outgoingClaims);
  let unclaimedIncoming = 0;
  let unclaimedOutgoing = 0;
  let unclaimedCompleted = 0;
  let complaintAttentionCount = 0;
  if (ready) {
    unclaimedIncoming = _.reduce(
      _.map(incomingClaims, (c) =>
        c?.assign.owners && !_.isString(c?.assign.owners.partner) ? 1 : 0
      ),
      (sum, n) => sum + n,
      0
    );
    unclaimedOutgoing = _.reduce(
      _.map(outgoingClaims, (c) =>
        c?.assign.owners && !_.isString(c?.assign.owners.partner) ? 1 : 0
      ),
      (sum, n) => sum + n,
      0
    );
    unclaimedCompleted = _.reduce(
      _.map(completedClaims, (c) =>
        c?.assign.owners && !_.isString(c?.assign.owners.partner) ? 1 : 0
      ),
      (sum, n) => sum + n,
      0
    );
    complaintAttentionCount = _.reduce(
      _.map(complaints, (c) =>
        String(c?.status || "").toUpperCase() !== "RESOLVED" ? 1 : 0
      ),
      (sum, n) => sum + n,
      0
    );
  }
  return {
    ready,
    incoming: {
      count: _.size(incomingClaims),
      unclaimed: unclaimedIncoming
    },
    outgoing: {
      count: _.size(outgoingClaims),
      unclaimed: unclaimedOutgoing
    },
    completed: {
      count: _.size(completedClaims),
      unclaimed: unclaimedCompleted
    },
    complaints: {
      count: _.size(complaints),
      attentionCount: complaintAttentionCount
    }
  };
};

export default compose<any>(
  withRouter,
  connect(preMapStateToProps),
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps)
)(Sidebar);
